<div class="w-full">
  <div class="flex flex-row flex-wrap shrink-0 wrap-1 border-white border-b-2">
    <div class="flex flex-column basis-full md:basis-1/2 border-r-2 textBox border-white no-wrap justify-content-center">
      <div class="flex flex-column text-white m-8">
        <h1 class="display-3 header-info-SK pb-2 border-b-2 border-white">Digital Fog.</h1>
        <p class="mt-2 descText text-white">An ongoing project and driving force in my photographic journey.
          Being a collection of images that portray the closest representation of my ideas and dreams.
          Pictures taken of the rollecoaster that is life, trough happiness and trough sadness,
          trough laughter and trough out tears. Besides the emotional inspiration,
          in the past year and counting i have gathered a serious throwback to the past utilising mostly old digital cameras.
        </p>
      </div>
    </div>
    <div class="basis-full md:basis-1/2 border-white bg-black mx-auto shrink-0 overflow-hidden">
      <video autoplay loop class="shrink-0 mx-auto w-100 h-[550px]">
        <source src="../../assets/synthC.mp4">
      </video>
    </div>
  </div>
  <div class="flex flex-column text-center p-2 bg-white">
    <h1 class="mx-auto display-5 header-info-upload text-krstic ">The Process.</h1>
    <p class="mt-2 descText text-krstic">Make the most out of old cameras. Embrace every imperfection. Corrupt image while still recognizable.</p>
    <p class="mt-4 descText text-krstic">Scroll to see the gallery...</p>
  </div>

</div>


<!--

<div class="masktv z-10 relative opacity-[99%]">
  <div class="absolute w-[40vw]">
  </div>
</div>
<div class=" mt-0 flex-lg-shrink-1 CRT jittertwo">
<div class="flex">
  <div class="px-0 user-select-none teletext text-white flex flex-col justify-center h-[100vh] mx-4">
    <img src="../../assets/Pfp.jpg" style="width: 5rem; height: auto; border-radius: 50%; box-shadow: 0.2rem 0.2rem 0.2rem rgba(21,21,21,0.1);" class="row h100 mx-auto mb-4 mt-1">
    <div class="row">
      <h3 class="text-center mx-auto">Luka Krstikj</h3>
    </div>
    <div class="row">
      <h5 class="mx-auto bg-[limegreen] text-krstic p-2 glow jitter flicker"></h5>
    </div>
  </div>
  <div class="teletext text-offblack flex flex-col xl:flex-row h-[95vh] overflow-hidden user-select-none my-4 text-white mx-16">
    <div class="basis-1/4 flex flex-col-reverse justify-around mt-24 md:mt-8">
      <div class="text-5xl xl:text-9xl mt-8 md:mt-24 w-fit">
        <h1 class="glow jitter flicker bg-[magenta] text-white w-fit">Luka</h1>
        <h1 class="ml-8 glow jitter flicker bg-[magenta] text-white w-fit">Krstikj</h1>
      </div>
      <div class="flex justify-end">
        <h1 class="text-sm md:text-md text-right mb-8 w-fit bg-[blue] text-[yellow] flicker jittertwo glow">[INFO]-></h1>
      </div>
    </div>
    <div class="flex flex-col justify-center basis-1/2">
      <div>
        <p class="text-lg md:text-xl w-100 xl:w-[35vw] bg-[limegreen] text-krstic p-1 glow jittertwo flicker">A {{age}} year old photographer
          and developer from Macedonia, currently studying at the Faculty of Computer Science & Engineering in Skopje.
          Currently working on numerous small projects, as well as diving into the world of abstract photography.
        </p>
      </div>
    </div>
  </div>
</div>
</div>
-->



HOME

<div class="lg: h-[100vh] overflow-hidden flex flex-col CRT select-none">
  <div class="teletext w-full text  flex justify-end h-[25px]">
    <div class="h-[25px] w-max checkered flex-1"></div>
    <div class="h-[25px] bg-white text-black flex flex-col justify-center">
      <h1 class="text-sm h-fit m-0 px-2" id="clock">00:00:00</h1>
    </div>
    <div class="h-[25px] bg-white text-black flex flex-col justify-center">
      <h1 class="text-sm h-fit m-0 px-2">v[3.03]</h1>
    </div>
  </div>
  <div class="titleWdesc text-white flex justify-between bg-[blue]">
    <img src="assets/logoLK.svg" class="w-[55%] md:w-[20%] pt-2 mb-0 pl-2">
    <div class="flex flicker">
      <div class="w-[12px] md:w-[30px] bg-[gray]"></div>
      <div class="w-[12px] md:w-[30px] bg-[yellow]"></div>
      <div class="w-[12px] md:w-[30px] bg-[cyan]"></div>
      <div class="w-[12px] md:w-[30px] bg-[limegreen]"></div>
      <div class="w-[12px] md:w-[30px] bg-[magenta]"></div>
      <div class="w-[12px] md:w-[30px] bg-[red]"></div>
      <div class="w-[12px] md:w-[30px] bg-[blue]"></div>
    </div>
  </div>
  <div class="flex-1 mx-0 pt-0 flex flex-col lg:flex-row-reverse wrap-1 justify-evenly teletext lg:overflow-hidden jittertwo">
    <div class="lg:basis-1/2 flex flex-col justify-center lg:px-32 text-white glow">
      <h1 class="bg-[limegreen] text-krstic w-full text-center mb-4 leading-tight md:leading-none glow telehead pt-2 text-5xl shadow-md shadow-[limegreen]">
        {{this.program}}
      </h1>
      <div class="flex flex-col justify-center w-full lg:w-75 px-0 navCH">
        <div routerLinkActive="active" routerLink="/dev" (mouseover)="hover('1', 'FDev.mp4','<Projects> /// <Apps>')" class="flex justify-between">
          <h1 class="text-[yellow]">Dev</h1>
          <h1>1</h1>
        </div>
        <div routerLinkActive="active" routerLink="/art" (mouseover)="hover('2', 'ahahah.mp4','Photos *** Visuals')" class="flex justify-between">
          <h1 class="text-[yellow]">Art</h1>
          <h1>2</h1>
        </div>
        <div (mouseover)="hover('934', 'konj.mp4','NO FURTHERFURTHERFURTHER INFORMATION')" class="flex justify-between">
          <h1 class="text-[yellow]">???</h1>
          <h1>934</h1>
        </div>
        <div routerLinkActive="active" routerLink="/about-me" (mouseover)="hover('10', 'Gsynth.mp4','About-Me &&& 07@Contact.com')" class="flex justify-between">
          <h1 class="text-[yellow]">About Me</h1>
          <h1>10</h1>
        </div>
      </div>
      <h1 class="text-[1.2rem] bg-[magenta] shadow-md shadow-[magenta] text-white text-center mt-4 w-full lg:w-75">The world is yours.</h1>
    </div>

    <div class="text-white lg:basis-1/2 flex flex-col justify-center flicker relative">
      <video playsinline autoplay muted loop poster="assets/ezgif.com-optimize-2.gif" class="" id="tv">
        <source src="assets/homeN.mp4" type="video/mp4">
      </video>
      <h1 id="ch" class="text-[limegreen] w-fit absolute text-2xl lg:text-5xl right-10 top-10 hidden"></h1>
      <div class="absolute text-center jitter ch">
        <h1 class="bg-black text-[limegreen] w-fit text-2xl lg:text-4xl">{{this.text[0]}}</h1>
        <h1 class="bg-black text-[limegreen] w-fit text-2xl lg:text-4xl">{{this.text[1]}}</h1>
        <h1 class="bg-black text-[limegreen] w-fit text-2xl lg:text-4xl">{{this.text[2]}}</h1>
      </div>

    </div>

  </div>
</div>
<div class="nBG teletext text-center flex flex-col justify-center pt-2 CRT">
  <h5>© 2024 Luka Krstikj</h5>
</div>
